

export const P_MANAGE_EVENTS = 'manage_events';
export const P_MANAGE_PERMISSIONS = 'manage_permissions';
export const P_MANAGE_PRODUCTS = 'manage_products';
export const P_MANAGE_SALES = 'manage_sales';
export const P_MANAGE_USERS = 'manage_users';